const SvgHero404 = (props) => (
  <svg viewBox="0 0 960 480" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="288" y="96" width="384" height="384" fill="#F2F2F2" />
    <path
      d="M576.001 383.999L384.002 192.001C437.021 138.982 522.982 138.982 576.001 192.001C629.02 245.02 629.02 330.98 576.001 383.999Z"
      fill="#EFAC26"
    />
    <path
      d="M383.999 192.001L575.998 383.999C522.979 437.018 437.018 437.018 383.999 383.999C330.98 330.98 330.98 245.02 383.999 192.001Z"
      fill="#3763FF"
    />
    <rect x="96" y="96" width="192" height="192" fill="#" />
    <rect x="96" y="288" width="192" height="192" fill="#" />
    <rect x="192" y="288" width="96" height="192" fill="#29A964" />
    <path d="M288 96V288H96L288 96Z" fill="#2525D7" />
    <path
      d="M144.001 239.998L239.999 143.999C266.509 170.509 266.509 213.489 239.999 239.998C213.49 266.508 170.51 266.508 144.001 239.998Z"
      fill="#EFAC26"
    />
    <path
      d="M239.999 143.999L144.001 239.998C117.491 213.489 117.491 170.509 144.001 143.999C170.51 117.49 213.49 117.49 239.999 143.999Z"
      fill="#D3DDFF"
    />
    <rect x="672" y="96" width="192" height="192" fill="#D3DDFF" />
    <rect x="672" y="288" width="192" height="192" fill="#F2D6BB" />
    <rect x="768" y="288" width="96" height="192" fill="#3763FF" />
    <path d="M864 96V288H672L864 96Z" fill="#BC6038" />
    <path
      d="M720.001 239.998L815.999 143.999C842.509 170.509 842.509 213.489 815.999 239.998C789.49 266.508 746.51 266.508 720.001 239.998Z"
      fill="#FCFCFC"
    />
    <path
      d="M815.999 143.999L720.001 239.998C693.491 213.489 693.491 170.509 720.001 143.999C746.51 117.49 789.49 117.49 815.999 143.999Z"
      fill="#F06C22"
    />
    <rect x="864" y="384" width="96" height="96" fill="#D3DDFF" />
    <rect x="672" width="96" height="96" fill="#F2F2F2" />
    <rect x="768" y="384" width="96" height="96" fill="#2525D7" />
    <path
      d="M480 288V480H432V384C432 357.48 410.52 336 384 336C357.48 336 336 357.48 336 384V480H288V288H480Z"
      fill="#D2D2D2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M356.558 344.607C348.342 326.685 344.234 307.342 344.234 288L479.998 288L479.999 288.002V423.763C463.717 423.764 447.434 420.853 431.999 415.031V384C431.999 357.48 410.519 336 383.999 336C373.793 336 364.334 339.181 356.558 344.607Z"
      fill="#363636"
    />
    <path d="M0 432C0 405.49 21.4903 384 48 384C74.5097 384 96 405.49 96 432V480H0V432Z" fill="#D0AE86" />
    <path d="M864 96L768 96L768 -4.19629e-06L864 96Z" fill="#F2D6BB" />
    <path d="M576 96L672 96L672 192L576 96Z" fill={props.color} />
  </svg>
);

export default SvgHero404;
